const s = {
  name: "CheckoutComponents",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,0h5v2h-3v3h-2V0z"/>
		<path class="st0" d="M38,2h-3V0h5v5h-2V2z"/>
		<path class="st0" d="M24,15v3h3v2h-5v-5H24z"/>
		<path class="st0" d="M38,18v-3h2v5h-5v-2H38z"/>
		<path class="st0" d="M24.7,29.7L19,35.4l-3.7-3.7l1.4-1.4l2.3,2.3l4.3-4.3L24.7,29.7z"/>
		<path class="st0" d="M3,24c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V27c0-1.7-1.3-3-3-3H3z M2,27c0-0.6,0.4-1,1-1
			h34c0.6,0,1,0.4,1,1v10c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V27z"/>
		<path class="st0" d="M18,0H0v20h18V0z M2,18V2h14v16H2z"/>
		<path class="st0" d="M33,20h-4v-2h4V20z"/>
		<path class="st0" d="M38,7v6h2V7H38z"/>
		<path class="st0" d="M22,13V7h2v6H22z"/>
		<path class="st0" d="M29,2h4V0h-4V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CheckoutComponents
};
